<template>
     <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '影片專區'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="img-block" v-for="item in tape" :key="item.tapeID">
                <a href="#" @click="video(item.tapeID)">
                    <img :src="item.tapeImage" :alt="item.tapeName">
                </a>
                <div class="image-caption">{{ item.tapeName }}</div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>
<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let tape = [
                {
                    tapeID: 'rq8uEQOl2H8',
                    tapeName: '台塑電子商務教學01-登入及註冊',
                    tapeImage: 'images/video/video01.jpg'
                },
                {
                    tapeID: 'U51Ie8n2e9A',
                    tapeName: '台塑電子商務教學02-下單流程',
                    tapeImage: 'images/video/video02.jpg'
                },
            ]

            return {
                tape: tape
            }
        },
        computed: {
            btns: function(){
                let $cancel = {
                        text: this.$t('site.func.popupclose'),
                        func: 'close',
                    }

                return [
                    $cancel,
                ]
            },
        },
        methods: {
            ...mapMutations([
                'pushPopUp'
            ]),
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
            video: function(filmID){
                let target = this.tape.filter(item => item.tapeID === filmID);

                this.pushPopUp({
                    type: 'videoBlock',
                    content: {
                        film: filmID,
                        caption: target[0].tapeName
                    }
                })
            }
        }
    }
</script>
<style scoped lang="scss">
    .pop-up-content {
       
        width: 80vw;
        height: 80vw; 

        .img-block {
            
            display: inline-block;
            width: calc(33.3% - #{$interval-s} * 2);
            position: relative;
            margin: 0 $interval-s;
            height: 0;
            padding-bottom: 24%;

            @include media('pc') {
                width: calc(50% - #{$interval-s} * 2);
                padding-bottom: 33.3%;
            }

            @include media('mobile') {
                width: 100%;
                padding-bottom: 72.25%;
                margin: 0;
            }

            a {
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;

                img {
                    position: absolute;
                    width: 100%;
                    height: 100% !important;
                    object-fit: cover;
                }
            }

            .image-caption {
                position: absolute;
                bottom: 0;
                text-align: center;
                line-height: $line-height-s;
                color: #fff;
                width: 100%;
                padding: $interval-m;
                font-size: $font-size-l;
                box-sizing: border-box;
            }
        }
    }
</style>